import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class WorkspaceService extends Subject<any> {

    private _CU0_ID: number;
    private _CU0_ALLOW_INVENTORY_MANAGEMENT: number;

    constructor() {
        super();
        this._CU0_ID = 0;
        this._CU0_ALLOW_INVENTORY_MANAGEMENT = 0;
    }

    public setWorkspaceMasterCustomer(masterCustomer: {[key: string]: any}) {
        this._CU0_ID = Number(masterCustomer.CU0_ID);
        this._CU0_ALLOW_INVENTORY_MANAGEMENT = Number(masterCustomer.CU0_ALLOW_INVENTORY_MANAGEMENT);
    }

    public get CU0_ID(): number {
        return this._CU0_ID;
    }

    public get CU0_ALLOW_INVENTORY_MANAGEMENT(): number {
        return this._CU0_ALLOW_INVENTORY_MANAGEMENT;
    }

    public next(value?: any) {
        if (!value) {
            value = {
                CU0_ID: this.CU0_ID,
                CU0_ALLOW_INVENTORY_MANAGEMENT: this.CU0_ALLOW_INVENTORY_MANAGEMENT
            }
        }
        super.next(value);
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/services/workspace.service.ts